import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import styled from '@emotion/styled';
import {
  CHAT_LIBRARY_SCOPE_ALL,
  CHAT_LIBRARY_SCOPE_RECENT,
} from './chatSessionListUtils';

const ScopeToggle = styled(ToggleButtonGroup)(({ theme }) => ({
  backgroundColor: 'transparent',
  borderRadius: 8,
  padding: 0,
  gap: 2,
  border: 'none',
  '& .MuiToggleButtonGroup-grouped': {
    border: 0,
    borderRadius: '8px !important',
    margin: 0,
    minWidth: 52,
    height: 32,
    padding: '0 12px',
    fontSize: 13,
    fontWeight: 600,
    lineHeight: 1.2,
    textTransform: 'none',
    color: theme.palette.text.secondary,
    transition: 'background-color 160ms ease, color 160ms ease',
  },
  '& .Mui-selected': {
    backgroundColor: `${
      theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.05)'
    } !important`,
    color: `${theme.palette.text.primary} !important`,
    boxShadow: 'none',
  },
  '& .MuiToggleButton-root:hover': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.04)',
  },
}));

/**
 * Lightweight All / Recent scope control for the Chat Library.
 */
export default function ChatLibraryScopeToggle({ value, onChange, disabled = false }) {
  const handleChange = (_event, nextValue) => {
    if (nextValue != null) onChange(nextValue);
  };

  return (
    <ScopeToggle
      exclusive
      size="small"
      value={value}
      onChange={handleChange}
      disabled={disabled}
      aria-label="Chat library scope"
      data-testid="chat-library-scope-toggle"
    >
      <ToggleButton
        value={CHAT_LIBRARY_SCOPE_ALL}
        aria-label="All chats"
        aria-pressed={value === CHAT_LIBRARY_SCOPE_ALL}
      >
        All
      </ToggleButton>
      <ToggleButton
        value={CHAT_LIBRARY_SCOPE_RECENT}
        aria-label="Recent chats"
        aria-pressed={value === CHAT_LIBRARY_SCOPE_RECENT}
      >
        Recent
      </ToggleButton>
    </ScopeToggle>
  );
}
